module.exports = __webpack_public_path__ + "img/primo_jino_logo.6f0fe670.png";